import { render, staticRenderFns } from "./TopView.vue?vue&type=template&id=1a805aa1&scoped=true&"
import script from "./TopView.vue?vue&type=script&lang=js&"
export * from "./TopView.vue?vue&type=script&lang=js&"
import style0 from "./TopView.vue?vue&type=style&index=0&id=1a805aa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a805aa1",
  null
  
)

export default component.exports